// extracted by mini-css-extract-plugin
var _1 = "LoginFormPhoneVerificationFields-modulecodeInputContainer__tMA_z";
export { _1 as "codeInputContainer" }
